var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldenStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0489 6.14999L11.8228 5.3517L9.48036 0.362201C9.3054 -0.0103822 8.69411 -0.0103822 8.51915 0.362201L6.1774 5.3517L0.951314 6.14999C0.522064 6.21587 0.350647 6.73791 0.651689 7.04604L4.44836 10.9376L3.5509 16.4392C3.47936 16.8763 3.94615 17.2042 4.33219 16.9896L9.00011 14.4099L13.668 16.9903C14.0505 17.2028 14.5216 16.8812 14.4493 16.44L13.5519 10.9383L17.3485 7.04674C17.6496 6.73791 17.4774 6.21587 17.0489 6.14999Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.5 0.0698242)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenStar);
export default __webpack_public_path__ + "static/media/golden-star.505650da00cb7b58e18d95cc413c6f78.svg";
export { ForwardRef as ReactComponent };